export class Invitation {
    InvitationText?: string;
    SubmitButtonText?: string;
}
